import { EvtHeader } from "components/header";
import React from "react";
import TeamForm from "../form";

const CreateTeam = () => {
  return (
    <div className="flex-1 max-w-md">
      <EvtHeader title="Create Team" />
      <div className="p-6 max-w-2xl">
        <TeamForm />
      </div>
    </div>
  );
};

export default CreateTeam;
